import { render } from "./datasetPropertiesAndLogs.vue?vue&type=template&id=79e63526&ts=true"
import script from "./datasetPropertiesAndLogs.vue?vue&type=script&lang=ts"
export * from "./datasetPropertiesAndLogs.vue?vue&type=script&lang=ts"

import "./datasetPropertiesAndLogs.vue?vue&type=style&index=0&id=79e63526&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__